module.exports = __webpack_public_path__ + "img/map.3aa3970f.png";